import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StatusService } from '../../services/status.service';
import { UsersService } from '@flashvpn-io/web-core';
import { Subscription } from 'rxjs';

interface NavItem {
    label: string;
    route: string;
    iconComponent: any;
    requiresAuth?: boolean;
    authOnly?: boolean; // 仅在已登录时显示
    guestOnly?: boolean; // 仅在未登录时显示
}

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
    allNavItems: NavItem[] = [
        // 仅未登录用户可见的项目
        // { iconComponent: 'LoginIconComponent', label: 'Menu.login', route: '/users/signin', requiresAuth: false, guestOnly: true },
        // { iconComponent: 'RegisterIconComponent', label: 'Menu.register', route: '/users/signup', requiresAuth: false, guestOnly: true },

        // 仅登录用户可见的项目
        { iconComponent: 'StarComponent', label: 'Menu.items.home', route: '/home', requiresAuth: true, authOnly: true },
        // { iconComponent: 'PencilComponent', label: '規則管理', route: '/rules-management', requiresAuth: true, authOnly: true },
        { iconComponent: 'DiamondComponent', label: 'Menu.items.subscription', route: '/subscription', requiresAuth: true, authOnly: true },
        { iconComponent: 'ListComponent', label: 'Menu.items.recharge', route: '/invoices', requiresAuth: true, authOnly: true },
        // { iconComponent: 'ScreensComponent', label: '裝置管理', route: '/devices', requiresAuth: true, authOnly: true },


        // 所有用户都可见的项目
        { iconComponent: 'ChatIconComponent', label: 'Menu.items.cs', route: '/cs', requiresAuth: false },
        { iconComponent: 'SettingsIconComponent', label: 'Menu.items.settings', route: '/settings', requiresAuth: true, authOnly: true },
    ];

    navItems: NavItem[] = [];
    currentRoute: string = '';
    public isLoggedIn = false;
    private routerSubscription: Subscription | null = null;

    constructor(
        private router: Router,
        private statusService: StatusService,
        private userService: UsersService,
    ) { }

    async ngOnInit(): Promise<void> {
        // 初始化时获取当前路由
        this.currentRoute = this.router.url;

        // 监听路由变化，同时检查登录状态
        this.routerSubscription = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(async (event: any) => {
            this.currentRoute = event.url;
            // 每次路由变化时检查登录状态
            this.checkLoginStatus();
        });

        // 初始化登录状态
        this.checkLoginStatus();
    }

    ngOnDestroy(): void {
        // 取消订阅，防止内存泄漏
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    // 检查登录状态并更新导航项
    async checkLoginStatus(): Promise<void> {
        this.isLoggedIn = await this.userService.isLoggedIn();
        this.updateNavItems();
    }

    // 根据登录状态更新导航项
    updateNavItems(): void {
        if (this.isLoggedIn) {
            // 已登录用户显示所有非guestOnly的导航项
            this.navItems = this.allNavItems.filter(item => !item.guestOnly);
        } else {
            // 未登录用户显示所有guestOnly的项目和不需要认证的项目
            this.navItems = this.allNavItems.filter(item => item.guestOnly || (!item.requiresAuth && !item.authOnly));
        }
    }

    isActive(route: string): boolean {
        return this.currentRoute === route || this.currentRoute.startsWith(route);
    }

    navigate(route: string): void {
        this.router.navigate([route]);
    }

    toggleConnectionStatus(): void {
        this.statusService.toggleStatus();
    }

    async logout(): Promise<void> {
        await this.userService.logout();
        this.router.navigate(['/users/signin']);
        // clear cache for extensions. note: extension and ui has different runtime
        this.statusService.clearCache();
        this.checkLoginStatus();
    }

    navigateToLogin(): void {
        this.router.navigate(['/users/signin']);
    }
}
